import apolloClient from '../../apolloClient';
import conversationsQueries from '../queries/conversations';
import conversationsMutations from '../mutations/conversations';

const getConversationsByUserId = async (variables) =>
  apolloClient.query({
    query: conversationsQueries.GET_CONVERSATIONS_BY_USER_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getConversationById = async (variables) =>
  apolloClient.query({
    query: conversationsQueries.GET_CONVERSATION_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getMessagesByConversationId = async (variables) =>
  apolloClient.query({
    query: conversationsQueries.GET_MESSAGES_BY_CONVERSATION_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const markConversationAsRead = async (variables) =>
  apolloClient.query({
    query: conversationsMutations.MARK_CONVERSATION_AS_READ,
    fetchPolicy: 'no-cache',
    variables,
  });

const syncMessagesByConversationId = async (variables) =>
  apolloClient.query({
    query: conversationsQueries.SYNC_MESSAGES_BY_CONVERSATION_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  getConversationsByUserId,
  getConversationById,
  getMessagesByConversationId,
  markConversationAsRead,
  syncMessagesByConversationId,
};
